import styled from "styled-components/macro";

export const SingleStar = styled.div`
  padding: 0px 4px;
  z-index: 9999;
  position: relative;

  svg path {
    fill: ${(props) => (props.isOn ? props.theme.colors.red : "rgba(255, 56, 92, 0.25)")};
    transition: 0.5s ease;
  }
`;

export const KanbanStars = styled.div`
  height: 16px;
  margin-top: 10px;
  background-color: transparent;
  border-radius: 15px;
  display: flex;
  align-items: center;
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  margin-left: -3px;
  z-index: 98;
  position: relative;

  span {
    display: flex;
    z-index: 2;
  }
`;
